import React, { useState, useEffect } from 'react';
import axios from 'axios';
import "bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStethoscope, faNotesMedical, faFilePrescription, faFloppyDisk, faArrowsRotate } from '@fortawesome/free-solid-svg-icons';
import PatientDetails from './PatientDetails';


export default function PatientNote() {

  //***************** Declare Variable *********************** */
  const API_URL = "http://localhost:5002/";
  const baseUrl = "https://mount.serveis.in/api/";
  const [checked, setChecked] = useState([]);
  const [categories, setCategories] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const uhid = localStorage.getItem('uhid');
    const lastUhid = localStorage.getItem('lastUhid');

    if (uhid && uhid === lastUhid) {
      // Load from localStorage to avoid API call
      const savedPatient = localStorage.getItem('patientDetails');
      if (savedPatient) {
        setPatientDetails(JSON.parse(savedPatient));
        return; // exit early, no API call
      }
    }
    if (uhid) {
      loadPatientByUhid(uhid, setPatientDetails);
    }
  }, []);


  const [patientnote, setPatientnote] = useState({
    Id: 0,
    Items: '',
    Disease: '',
    MedicineTaken: '',
    PatientId: '',
    VisitId: '',
    UserId: ''
  });

  const [patientDetails, setPatientDetails] = useState({
    id: 0,
    clientId: 0,
    code: '',
    name: '',
    age: null,
    gender: '',
    mobileNo: '',
    bloodGroup: '',
    height: null,
    weight: null,
    bmi: null,
    emailId: '',
    address: '',
    pincode: null,
    aadharNo: '',
    status: true,
    isDeleted: false,
    createdBy: '',
    createdDate: '',
    lastModifiedBy: '',
    lastModifiedDate: '',

    // Items: '',
    // Disease: '',
    // MedicineTaken: '',
    // VisitId: '',
    // UserId: ''
  });


  //************************** Get Categoies*/

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPatientnote({ ...patientnote, [name]: value });
  }

  const fetchCategories = async () => {
    try {
      const response = await axios.get(API_URL + "api/categories");
      // console.log(response);
      setCategories(response.data.empData);
      //setId(response.data.empData.Id);
    }
    catch (error) {
      console.log(error);
    }
  };


  const handleCheck = (event) => {
    var updatedList = [...checked];
    if (event.target.checked) {
      updatedList = [...checked, event.target.value];
    }
    else {
      updatedList.splice(checked.indexOf(event.target.value), 1);
    }
    patientnote.Items = updatedList.toString();
    setChecked(updatedList);
  };


  //******************** Get Data By Id **************************/
  const handleClick = async (visitid) => {
    try {
      const response = await axios.get(`${API_URL + "api/getPatientNoteById"}/${visitid}`);
      console.log(response);
      setPatientnote(response.data.empData);
      //setCategories(response.data.empData.Items);
      debugger;
      const apiResponse = response.data.empData.Items; // "apple,banana,grape"; // Simulate API response
      const selected = apiResponse.split(",");
      setChecked(selected);
    }
    catch (error) {
      console.log(error);
    }
  }

  const loadPatientByUhid = async (uhid, setPatientDetails) => {
    try {
      if (!uhid) return;

      const token = localStorage.getItem('access_token');

      const response = await axios.get(`${baseUrl}PatientMaster/GetByUhid/${uhid}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.data && response.data.length > 0) {
        const patientData = response.data[0];
        setPatientDetails(patientData);

        // Save to localStorage
        localStorage.setItem('lastUhid', uhid);
        localStorage.setItem('patientDetails', JSON.stringify(patientData));
      } else {
        setPatientDetails({});
      }
    } catch (error) {
      if (error.response) {
        console.log("Response Error:", error.response.data);
        console.log("Status:", error.response.status);
      } else {
        console.log("Error:", error.message);
      }
    }
  };


  //******************************** Add / Update Data************************ */
  const handleAdd = async () => {
    try {
      debugger;
      if (patientnote.Id > 0) {
        axios.put(`${API_URL + "api/UpdatePatientNote"}/${patientnote.Id}`, patientnote, { timeout: 10000 }) // 10 seconds timeout
          .then(response => {
            toast.success("Patient Note update successfully");
            setPatientnote({
              Id: 0,
              Items: '',
              Disease: '',
              MedicineTaken: '',
              PatientId: '',
              VisitId: '',
              UserId: ''
            });

          }).catch(err => {
            console.log(err);
          });

      }
      else {
        axios.post(API_URL + "api/AddPatientNote", patientnote, { timeout: 10000 })
          .then(response => {
            toast.success("Patient Note saved successfully");
            setPatientnote({
              Id: 0,
              Items: '',
              Disease: '',
              MedicineTaken: '',
              PatientId: '',
              VisitId: '',
              UserId: ''
            });
          }).catch(err => {
            console.log(err);
          });
      }
    }
    catch (error) {
      console.log(error);
    }
  }

  // **************************** Reset Data ***************************/

  const handleReset = async () => {
    setPatientnote({
      Id: 0,
      Items: '',
      Disease: '',
      MedicineTaken: '',
      PatientId: '',
      VisitId: '',
      UserId: ''
    });
  }

  // ******************************** Design Part ********************************

  return (
    <div className="container">
      <ToastContainer position="bottom-left" />
      <form>

        <PatientDetails
          patientDetails={patientDetails}
          loadPatientByUhid={(uhid) => loadPatientByUhid(uhid)}
        />


        <div style={{ height: "10px" }}></div>
        <div className="mb-2">
          <div className="d-flex flex-wrap">
            <FontAwesomeIcon style={{ cursor: 'pointer', fontSize: "25px" }} icon={faStethoscope} />
            {categories.map(category => (
              <label key={category.DiseaseCode}>
                <input
                  className="form-check-input"
                  type="checkbox"
                  value={category.DiseaseCode}
                  onChange={handleCheck}
                  checked={checked.includes(category.DiseaseCode)}
                />
                <label className="form-check-label" style={{ fontSize: "16px" }}>
                  {category.DiseaseName}
                </label>

              </label>
            ))}
          </div>
          {/* <small className="text-muted d-block mt-1">Checked: <strong>{checkedItems}</strong></small> */}
        </div>

        {/* Other Disease */}
        <div className="mb-2">

          {/* <label style={{ cursor: 'pointer' }}>
            <i className="fa-solid fa-notes-medical" style={{fontSize:"25px"}}></i>  
          </label> */}
          <FontAwesomeIcon style={{ cursor: 'pointer', fontSize: "25px" }} icon={faNotesMedical} />
          <label htmlFor="txtDisease" className="form-label fw-bold">If any Other Disease be specify:</label>
          <input
            type="text"
            id="txtDisease"
            className="form-control"
            name="Disease"
            value={patientnote.Disease}
            onChange={handleInputChange}
            style={{ height: "32px", fontSize: "14px", padding: "5px" }}
          />
        </div>

        {/* Medicine Taken */}
        <div className="mb-2">
          {/* <label  style={{ cursor: 'pointer' }}>
            <i className="fa-solid fa-file-prescription" style={{fontSize:"25px"}}></i>  
          </label> */}
          <FontAwesomeIcon style={{ cursor: 'pointer', fontSize: "25px" }} icon={faFilePrescription} />
          <label htmlFor="txtMedicineTaken" className="form-label fw-bold">Medicine Taken:</label>
          <textarea
            id="txtMedicineTaken"
            rows="3"
            className="form-control"
            name="MedicineTaken"
            value={patientnote.MedicineTaken}
            onChange={handleInputChange}
            style={{ fontSize: "14px", padding: "5px" }}
          ></textarea>
        </div>

        {/* Buttons */}
        <div className="d-flex justify-content-end gap-2">
          <button type="reset" id="btnRefresh" style={{ display: 'none' }} onClick={handleReset} className="btn btn-danger btn-sm px-3">
            Reset
          </button>
          <button type="button" id="btnSave" style={{ display: 'none' }} onClick={handleAdd} className="btn btn-primary btn-sm px-3">
            Save
          </button>


          {/* <label htmlFor="btnSave"  style={{ cursor: 'pointer' }}>
            <i className="fa-solid fa-floppy-disk" style={{fontSize:"25px"}}></i>  
          </label>
          &nbsp;
          <label htmlFor="btnRefresh"  style={{ cursor: 'pointer' }}>
            <i className="fa-solid fa-arrows-rotate" style={{fontSize:"25px"}}></i>  
          </label> */}
          {/* <FontAwesomeIcon onClick={handleAdd} style={{ cursor: 'pointer' ,fontSize:"25px"}} icon={faFloppyDisk} />
          &nbsp;
          <FontAwesomeIcon onClick={handleReset}  style={{ cursor: 'pointer' ,fontSize:"25px"}} icon={faArrowsRotate} /> */}


          <label htmlFor="btnSave" style={{ cursor: 'pointer', fontSize: "15px" }} className="btn btn-success btn-sm px-2 py-1">
            {/* <i className="fa-solid fa-floppy-disk" style={{fontSize:"25px"}}></i>   */}
            <FontAwesomeIcon style={{ cursor: 'pointer', fontSize: "16px" }} icon={faFloppyDisk} /> &nbsp;Save
          </label>

          <label htmlFor="btnRefresh" style={{ cursor: 'pointer', fontSize: "15px" }} className="btn btn-danger btn-sm px-2 py-1">
            {/* <i className="fa-solid fa-arrows-rotate" style={{fontSize:"25px"}}></i>   */}
            <FontAwesomeIcon style={{ cursor: 'pointer', fontSize: "16px" }} icon={faArrowsRotate} />&nbsp;Clear
          </label>
        </div>
      </form>
    </div>
  );
}
